import {
  getShipmentList,
  getOtif,
  getShipmentDetail,
  getShipmentHistory,
  getShipmentDocument,
  downloadShipmentDocument,
  uploadShipmentDocument,
  getShipmentPrice,
  downloadShipmentInvoice,
  getShipmentInvoice,
  addShipmentRequest,
  getLeadtime,
  updateShipmentDetails,
  downloadPriceDetail,
  getUser,
  getDelayLog,
  filterShipment,
  downloadEfbl
  
} from '@/api/shipment.api'

export const FETCH_SHIPMENT_LIST = 'FETCH_SHIPMENT_LIST'
export const FETCH_SHIPMENT_LIST_LOADING = 'FETCH_SHIPMENT_LIST_LOADING'
export const FETCH_SHIPMENT_LIST_DONE = 'FETCH_SHIPMENT_LIST_DONE'
export const FETCH_SHIPMENT_LIST_ERROR = 'FETCH_SHIPMENT_LIST_ERROR'

export const FILTER_SHIPMENT = 'FILTER_SHIPMENT'
export const FILTER_SHIPMENT_LOADING = 'FILTER_SHIPMENT_LOADING'
export const FILTER_SHIPMENT_DONE = 'FILTER_SHIPMENT_DONE'
export const FILTER_SHIPMENT_ERROR = 'FILTER_SHIPMENT_ERROR'

export const FETCH_OTIF = 'FETCH_OTIF'
export const FETCH_OTIF_LOADING = 'FETCH_OTIF_LOADING'
export const FETCH_OTIF_DONE = 'FETCH_OTIF_DONE'
export const FETCH_OTIF_ERROR = 'FETCH_OTIF_ERROR'

export const FETCH_SHIPMENT_DETAIL = 'FETCH_SHIPMENT_DETAIL'
export const FETCH_SHIPMENT_DETAIL_LOADING = 'FETCH_SHIPMENT_DETAIL_LOADING'
export const FETCH_SHIPMENT_DETAIL_DONE = 'FETCH_SHIPMENT_DETAIL_DONE'
export const FETCH_SHIPMENT_DETAIL_ERROR = 'FETCH_SHIPMENT_DETAIL_ERROR'

export const FETCH_SHIPMENT_HISTORY = 'FETCH_SHIPMENT_HISTORY'
export const FETCH_SHIPMENT_HISTORY_LOADING = 'FETCH_SHIPMENT_HISTORY_LOADING'
export const FETCH_SHIPMENT_HISTORY_DONE = 'FETCH_SHIPMENT_HISTORY_DONE'
export const FETCH_SHIPMENT_HISTORY_ERROR = 'FETCH_SHIPMENT_HISTORY_ERROR'

export const FETCH_SHIPMENT_DOCUMENT = 'FETCH_SHIPMENT_DOCUMENT'
export const FETCH_SHIPMENT_DOCUMENT_LOADING = 'FETCH_SHIPMENT_DOCUMENT_LOADING'
export const FETCH_SHIPMENT_DOCUMENT_DONE = 'FETCH_SHIPMENT_DOCUMENT_DONE'
export const FETCH_SHIPMENT_DOCUMENT_ERROR = 'FETCH_SHIPMENT_DOCUMENT_ERROR'

export const DOWNLOAD_SHIPMENT_DOCUMENT = 'DOWNLOAD_SHIPMENT_DOCUMENT'
export const DOWNLOAD_SHIPMENT_DOCUMENT_LOADING = 'DOWNLOAD_SHIPMENT_DOCUMENT_LOADING'
export const DOWNLOAD_SHIPMENT_DOCUMENT_DONE = 'DOWNLOAD_SHIPMENT_DOCUMENT_DONE'
export const DONWLOAD_SHIPMENT_DOCUMENT_ERROR = 'DONWLOAD_SHIPMENT_DOCUMENT_ERROR'

export const UPLOAD_SHIPMENT_DOCUMENT = 'UPLOAD_SHIPMENT_DOCUMENT'
export const UPLOAD_SHIPMENT_DOCUMENT_LOADING = 'UPLOAD_SHIPMENT_DOCUMENT_LOADING'
export const UPLOAD_SHIPMENT_DOCUMENT_DONE = 'UPLOAD_SHIPMENT_DOCUMENT_DONE'
export const UPLOAD_SHIPMENT_DOCUMENT_ERROR = 'UPLOAD_SHIPMENT_DOCUMENT_ERROR'

export const FETCH_SHIPMENT_PRICE = 'FETCH_SHIPMENT_PRICE'
export const FETCH_SHIPMENT_PRICE_LOADING = 'FETCH_SHIPMENT_PRICE_LOADING'
export const FETCH_SHIPMENT_PRICE_DONE = 'FETCH_SHIPMENT_PRICE_DONE'
export const FETCH_SHIPMENT_PRICE_ERROR = 'FETCH_SHIPMENT_PRICE_ERROR'

export const DOWNLOAD_SHIPMENT_INVOICE = 'DOWNLOAD_SHIPMENT_INVOICE'
export const DOWNLOAD_SHIPMENT_INVOICE_LOADING = 'DOWNLOAD_SHIPMENT_INVOICE_LOADING'
export const DOWNLOAD_SHIPMENT_INVOICE_DONE = 'DOWNLOAD_SHIPMENT_INVOICE_DONE'
export const DOWNLOAD_SHIPMENT_INVOICE_ERROR = 'DOWNLOAD_SHIPMENT_INVOICE_ERROR'

export const FETCH_SHIPMENT_INVOICE = 'FETCH_SHIPMENT_INVOICE'
export const FETCH_SHIPMENT_INVOICE_LOADING = 'FETCH_SHIPMENT_INVOICE_LOADING'
export const FETCH_SHIPMENT_INVOICE_DONE = 'FETCH_SHIPMENT_INVOICE_DONE'
export const FETCH_SHIPMENT_INVOICE_ERROR = 'FETCH_SHIPMENT_INVOICE_ERROR'

export const DOWNLOAD_PRICE_DETAIL = 'DOWNLOAD_PRICE_DETAIL'
export const DOWNLOAD_PRICE_DETAIL_LOADING = 'DOWNLOAD_PRICE_DETAIL_LOADING'
export const DOWNLOAD_PRICE_DETAIL_DONE = 'DOWNLOAD_PRICE_DETAIL_DONE'
export const DOWNLOAD_PRICE_DETAIL_ERROR = 'DOWNLOAD_PRICE_DETAIL_ERROR'

// ADD SHIPMENT REQUEST
export const POST_SHIPMENT_REQUEST = 'POST_SHIPMENT_REQUEST'
export const POST_SHIPMENT_REQUEST_LOADING = 'POST_SHIPMENT_REQUEST_LOADING'
export const POST_SHIPMENT_REQUEST_DONE = 'POST_SHIPMENT_REQUEST_DONE'
export const POST_SHIPMENT_REQUEST_ERROR = 'POST_SHIPMENT_REQUEST_ERROR'

// GET LEAD TIME
export const GET_LEADTIME = 'GET_LEADTIME'
export const GET_LEADTIME_LOADING = 'GET_LEADTIME_LOADING'
export const GET_LEADTIME_DONE = 'GET_LEADTIME_DONE'
export const GET_LEADTIME_ERROR = 'GET_LEADTIME_ERROR'

// UPDATE SHIPMENT DETAILS
export const UPDATE_SHIPMENT_DETAILS = 'UPDATE_SHIPMENT_DETAILS'
export const UPDATE_SHIPMENT_DETAILS_LOADING = 'UPDATE_SHIPMENT_DETAILS_LOADING'
export const UPDATE_SHIPMENT_DETAILS_DONE = 'UPDATE_SHIPMENT_DETAILS_DONE'
export const UPDATE_SHIPMENT_DETAILS_ERROR = 'UPDATE_SHIPMENT_DETAILS_ERROR'

// GET ACTIVE USER
export const FETCH_ACTIVE_USER = 'FETCH_ACTIVE_USER'
export const FETCH_ACTIVE_USER_LOADING = 'FETCH_ACTIVE_USER_LOADING'
export const FETCH_ACTIVE_USER_DONE = 'FETCH_ACTIVE_USER_DONE'
export const FETCH_ACTIVE_USER_ERROR = 'FETCH_ACTIVE_USER_ERROR'

// GET PENDING USER
export const FETCH_PENDING_USER = 'FETCH_PENDING_USER'
export const FETCH_PENDING_USER_LOADING = 'FETCH_PENDING_USER_LOADING'
export const FETCH_PENDING_USER_DONE = 'FETCH_PENDING_USER_DONE'
export const FETCH_PENDING_USER_ERROR = 'FETCH_PENDING_USER_ERROR'

export const GET_DELAY_LOG = 'GET_DELAY_LOG'
export const GET_DELAY_LOG_LOADING = 'GET_DELAY_LOG_LOADING'
export const GET_DELAY_LOG_DONE = 'GET_DELAY_LOG_DONE'
export const GET_DELAY_LOG_ERROR = 'GET_DELAY_LOG_ERROR'

export const DOWNLOAD_EFBL = 'DOWNLOAD_EFBL'
export const DOWNLOAD_EFBL_LOADING = 'DOWNLOAD_EFBL_LOADING'
export const DOWNLOAD_EFBL_DONE = 'DOWNLOAD_EFBL_DONE'
export const DOWNLOAD_EFBL_ERROR = 'DOWNLOAD_EFBL_ERROR'

export default {
  [FETCH_SHIPMENT_LIST] (context, {type, currentPage, perPage}) {
    context.commit(FETCH_SHIPMENT_LIST_LOADING)
    return getShipmentList(type, currentPage, perPage)
      .then((response) => {
        context.commit(FETCH_SHIPMENT_LIST_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_LIST_ERROR, true)
        console.error(error)
      })
  },

  [FILTER_SHIPMENT] (context, { payload, perPage }) {
    context.commit(FILTER_SHIPMENT_LOADING)
    return filterShipment(payload.page, payload.type, payload.filter, payload.key, perPage)
      .then((response) => {
        context.commit(FILTER_SHIPMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(FILTER_SHIPMENT_ERROR, error)
      })
  },

  [FETCH_OTIF] (context, {shipmentId, orderNumber}) {
    context.commit(FETCH_OTIF_LOADING)
    return getOtif({shipmentId, orderNumber})
      .then((response) => {
        context.commit(FETCH_OTIF_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_OTIF_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_SHIPMENT_DETAIL] (context, {shipmentId, orderNumber}) {
    context.commit(FETCH_SHIPMENT_DETAIL_LOADING)
    return getShipmentDetail({shipmentId, orderNumber})
      .then((response) => {
        context.commit(FETCH_SHIPMENT_DETAIL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_DETAIL_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_SHIPMENT_HISTORY] (context, {shipmentId, orderNumber}) {
    context.commit(FETCH_SHIPMENT_HISTORY_LOADING)
    return getShipmentHistory({shipmentId, orderNumber})
      .then((response) => {
        context.commit(FETCH_SHIPMENT_HISTORY_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_HISTORY_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_SHIPMENT_DOCUMENT] (context, {shipmentId, orderNumber}) {
    context.commit(FETCH_SHIPMENT_DOCUMENT_LOADING)
    return getShipmentDocument({shipmentId, orderNumber})
      .then((response) => {
        context.commit(FETCH_SHIPMENT_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_DOCUMENT_ERROR, true)
        console.error(error)
      })
  },

  [DOWNLOAD_SHIPMENT_DOCUMENT] (context, {shipmentId, orderNumber, type, fileName, fileCategory, fileId}) {
    context.commit(DOWNLOAD_SHIPMENT_DOCUMENT_LOADING)
    return downloadShipmentDocument({shipmentId, orderNumber, type, fileName, fileCategory, fileId})
      .then((response) => {
        context.commit(DOWNLOAD_SHIPMENT_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(DONWLOAD_SHIPMENT_DOCUMENT_ERROR, true)
        console.error(error)
      })
  },

  [UPLOAD_SHIPMENT_DOCUMENT] (context, formData) {
    context.commit(UPLOAD_SHIPMENT_DOCUMENT_LOADING)
    return uploadShipmentDocument(formData)
      .then((response) => {
        context.commit(UPLOAD_SHIPMENT_DOCUMENT_DONE, response)
      })
      .catch((error) => {
        context.commit(UPLOAD_SHIPMENT_DOCUMENT_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_SHIPMENT_PRICE] (context, {shipmentId, orderNumber}) {
    context.commit(FETCH_SHIPMENT_PRICE_LOADING)
    return getShipmentPrice({shipmentId, orderNumber})
      .then((response) => {
        context.commit(FETCH_SHIPMENT_PRICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_PRICE_ERROR, true)
        console.error(error)
      })
  },

  [DOWNLOAD_SHIPMENT_INVOICE] (context, {shipmentId, orderNumber, invoiceId, fileName}) {
    context.commit(DOWNLOAD_SHIPMENT_INVOICE_LOADING)
    return downloadShipmentInvoice({shipmentId, orderNumber, invoiceId, fileName})
      .then((response) => {
        context.commit(DOWNLOAD_SHIPMENT_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_SHIPMENT_INVOICE_ERROR, true)
        console.error(error)
      })
  },

  [FETCH_SHIPMENT_INVOICE] (context, shipmentId) {
    context.commit(FETCH_SHIPMENT_INVOICE_LOADING)
    return getShipmentInvoice(shipmentId)
      .then((response) => {
        context.commit(FETCH_SHIPMENT_INVOICE_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_SHIPMENT_INVOICE_ERROR, true)
        console.error(error)
      })
  },

  [POST_SHIPMENT_REQUEST] (context, {shipmentId, orderNumber}) {
    context.commit(POST_SHIPMENT_REQUEST_LOADING)
    return addShipmentRequest({shipmentId, orderNumber})
      .then((response) => {
        context.commit(POST_SHIPMENT_REQUEST_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_SHIPMENT_REQUEST_ERROR, true)
        console.error(error)
      })
  },

  [GET_LEADTIME] (context, {shipmentId, orderNumber}) {
    context.commit(GET_LEADTIME_LOADING)
    return getLeadtime({shipmentId, orderNumber})
      .then((response) => {
        context.commit(GET_LEADTIME_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_LEADTIME_ERROR, true)
        console.error(error)
      })
  },

  [UPDATE_SHIPMENT_DETAILS] (context, {
    payload, shipmentId, orderNumber, type
  }) {
    context.commit(UPDATE_SHIPMENT_DETAILS_LOADING)
    return updateShipmentDetails({
      payload, shipmentId, orderNumber, type
    })
      .then((response) => {
        context.commit(UPDATE_SHIPMENT_DETAILS_DONE, response)
      })
      .catch((error) => {
        context.commit(UPDATE_SHIPMENT_DETAILS_ERROR, error)
      })
  },

  [DOWNLOAD_PRICE_DETAIL] (context, { shipmentId, fileName }) {
    context.commit(DOWNLOAD_PRICE_DETAIL_LOADING)
    return downloadPriceDetail(shipmentId, fileName)
      .then((response) => {
        context.commit(DOWNLOAD_PRICE_DETAIL_DONE, response)
      })
      .catch((error) => {
        context.commit(DOWNLOAD_PRICE_DETAIL_ERROR, error)
      })
  },

  [FETCH_ACTIVE_USER] (context, idShipment) {
    context.commit(FETCH_ACTIVE_USER_LOADING)
    return getUser('active', idShipment)
      .then((response) => {
        context.commit(FETCH_ACTIVE_USER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_ACTIVE_USER_ERROR, error)
      })
  },

  [FETCH_PENDING_USER] (context, idShipment) {
    context.commit(FETCH_PENDING_USER_LOADING)
    return getUser('pending', idShipment)
      .then((response) => {
        context.commit(FETCH_PENDING_USER_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PENDING_USER_ERROR, error)
      })
  },

  [GET_DELAY_LOG] (context, { shipmentId, orderNumber }) {
    context.commit(GET_DELAY_LOG_LOADING)
    return getDelayLog(shipmentId, orderNumber)
      .then((response) => {
        context.commit(GET_DELAY_LOG_DONE, response)
      })
      .catch((error) => {
        context.commit(GET_DELAY_LOG_ERROR, error)
      })
  },

  [DOWNLOAD_EFBL] (context, data) {
    context.commit(DOWNLOAD_EFBL_LOADING)
    return downloadEfbl(data)
      .then((response) => {
        context.commit(DOWNLOAD_EFBL_DONE, response)
      })
      .catch((error) => {
        console.log('error : ', error)
        context.commit(DOWNLOAD_EFBL_ERROR, error)
      })
  }

}



// WEBPACK FOOTER //
// ./src/store/modules/shipment/actions.js